import { render, staticRenderFns } from "./PatientLabResultsCard.vue?vue&type=template&id=c0e75896&scoped=true&"
import script from "./PatientLabResultsCard.vue?vue&type=script&lang=js&"
export * from "./PatientLabResultsCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientLabResultsCard.vue?vue&type=style&index=0&id=c0e75896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e75896",
  null
  
)

export default component.exports